export const emergencyStates = {
	inDanger: 'In danger',
	notInDanger: "I'm fine",
};
